import React from "react";
import { MdSummarize } from "react-icons/md";

const CustomQuillToolbar = () => {
  return (
    <div id="custom-toolbar">
      <select className="ql-font">
        <option value="Kumbh Sans" selected>
          Kumbh Sans
        </option>
      </select>
      <select className="ql-header">
        <option value="1" />
        <option value="2" />
        <option value="3" />
        <option value="4" />
        <option value="5" />
        <option value="6" />
        <option selected />
      </select>
      <button className="ql-bold" />
      <button className="ql-italic" />
      <button className="ql-underline" />
      <button className="ql-strike" />
      <select className="ql-color" />
      <select className="ql-background" />
      <button className="ql-script" value="sub" />
      <button className="ql-script" value="super" />
      <button className="ql-blockquote" />
      <button className="ql-code-block" />
      <button className="ql-list" value="ordered" />
      <button className="ql-list" value="bullet" />
      <button className="ql-indent" value="-1" />
      <button className="ql-indent" value="+1" />
      <button className="ql-direction" value="rtl" />
      <select className="ql-align" />
      <button className="ql-link" />
      <button className="ql-image" />
      <button className="ql-clean" />

      <button className="ql-tldr" title="Mark as TL;DR">
        <MdSummarize />
      </button>
    </div>
  );
};

export default CustomQuillToolbar;
